export const lodgingTab = 'lodging' as const;
export const permitTab = 'permit' as const;
export const inspectionTab = 'inspection' as const;
export const formsTab = 'forms' as const;
export const formsDashboardTab = 'formsDashboard' as const;
export const projectResourceTabs = [
  lodgingTab,
  permitTab,
  inspectionTab,
  formsTab,
  formsDashboardTab,
] as const;
